import { Tooltip, TooltipContentWithArrow, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';
import React from 'react';
import { getAppTitle, Icon } from 'venn-ui-kit';
import { cn } from '@/lib/utils';

const HoldingsProxyInfoIcon = () => {
  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <span>
          <Icon prefix="far" type="circle-info" />
        </span>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContentWithArrow side="top" className={cn('w-[350px]')}>
          Holdings data is only available for public mutual funds, ETFs, and stocks that are provided by {getAppTitle()}
          , and are not available for indices or user-uploaded data.
        </TooltipContentWithArrow>
      </TooltipPortal>
    </Tooltip>
  );
};

export default HoldingsProxyInfoIcon;
